import React from 'react';

interface AvatarProps {
  src?: string;
  alt?: string;
  children?: React.ReactNode;
  sx?: Omit<React.CSSProperties, 'border'> & {
    display?: string | { xs?: string; sm?: string; md?: string };
    width?: string | number;
    height?: string | number;
    p?: number;
    px?: number;
    py?: number;
    m?: number;
    mx?: number;
    my?: number;
    mt?: number;
    mb?: number;
    ml?: number;
    mr?: number;
    bgcolor?: string;
    color?: string;
    border?: string;
    borderRadius?: number | string;
    boxShadow?: number | string;
    alignItems?: string;
    justifyContent?: string;
    [key: string]: any;
  };
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({
  src,
  alt,
  children,
  sx,
  className = '',
}) => {
  const style: React.CSSProperties = {
    width: 40,
    height: 40,
    ...(sx?.width && { width: typeof sx.width === 'number' ? `${sx.width}px` : sx.width }),
    ...(sx?.height && { height: typeof sx.height === 'number' ? `${sx.height}px` : sx.height }),
    ...(sx?.p && { padding: `${sx.p * 0.25}rem` }),
    ...(sx?.px && { paddingLeft: `${sx.px * 0.25}rem`, paddingRight: `${sx.px * 0.25}rem` }),
    ...(sx?.py && { paddingTop: `${sx.py * 0.25}rem`, paddingBottom: `${sx.py * 0.25}rem` }),
    ...(sx?.m && { margin: `${sx.m * 0.25}rem` }),
    ...(sx?.mx && { marginLeft: `${sx.mx * 0.25}rem`, marginRight: `${sx.mx * 0.25}rem` }),
    ...(sx?.my && { marginTop: `${sx.my * 0.25}rem`, marginBottom: `${sx.my * 0.25}rem` }),
    ...(sx?.mt && { marginTop: `${sx.mt * 0.25}rem` }),
    ...(sx?.mb && { marginBottom: `${sx.mb * 0.25}rem` }),
    ...(sx?.ml && { marginLeft: `${sx.ml * 0.25}rem` }),
    ...(sx?.mr && { marginRight: `${sx.mr * 0.25}rem` }),
    ...(sx?.bgcolor && { backgroundColor: sx.bgcolor }),
    ...(sx?.color && { color: sx.color }),
    ...(sx?.border && { border: sx.border }),
    ...(sx?.borderRadius && { borderRadius: typeof sx.borderRadius === 'number' ? `${sx.borderRadius}px` : sx.borderRadius }),
    ...(sx?.boxShadow && { boxShadow: typeof sx.boxShadow === 'number' ? `0 ${sx.boxShadow}px ${sx.boxShadow * 2}px rgba(0,0,0,0.1)` : sx.boxShadow }),
    ...(sx && typeof sx === 'object' && !Array.isArray(sx) ? (() => {
      const rest: Record<string, any> = {};
      Object.keys(sx).forEach(key => {
        if (!['display', 'width', 'height', 'p', 'px', 'py', 'm', 'mx', 'my', 'mt', 'mb', 'ml', 'mr', 'bgcolor', 'color', 'border', 'borderRadius', 'boxShadow', 'alignItems', 'justifyContent'].includes(key)) {
          rest[key] = sx[key];
        }
      });
      return rest;
    })() : {}),
  };

  return (
    <div
      className={`inline-flex items-center justify-center rounded-full bg-gray-300 dark:bg-gray-700 text-gray-600 dark:text-gray-300 overflow-hidden ${className}`}
      style={style}
    >
      {src ? (
        <img src={src} alt={alt} className="w-full h-full object-cover" />
      ) : (
        children
      )}
    </div>
  );
};

export default Avatar;

